import { supabase } from "@/integrations/supabase/client";

// Bucket público de mídia do RDO. Escrita/exclusão restritas ao dono via RLS
// (prefixo `{uid}/` no path). Leitura pública para suportar o link /rdo-public/:id.
const BUCKET = "rdo-fotos";

export interface UploadedMedia {
  /** URL pública estável, persistida no payload do RDO. */
  url: string;
  /** Path no bucket (`{uid}/arquivo`), usado para excluir depois. */
  path: string;
}

function extensionOf(file: File): string {
  const fromName = /\.([a-zA-Z0-9]+)$/.exec(file.name)?.[1];
  if (fromName) return fromName.toLowerCase();
  const fromType = file.type.split("/")[1];
  return fromType || "jpg";
}

/** Sobe uma imagem para o Storage e devolve a URL pública persistente. */
export async function uploadRdoPhoto(file: File): Promise<UploadedMedia> {
  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (!user) throw new Error("Usuário não autenticado");

  const rand = Math.random().toString(36).slice(2, 10);
  const path = `${user.id}/${Date.now()}_${rand}.${extensionOf(file)}`;

  const { error } = await supabase.storage.from(BUCKET).upload(path, file, {
    cacheControl: "3600",
    upsert: false,
    contentType: file.type || undefined,
  });
  if (error) throw error;

  const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
  return { url: data.publicUrl, path };
}

/** Remove um arquivo do Storage (silencioso se o path for vazio). */
export async function deleteRdoPhoto(path?: string): Promise<void> {
  if (!path) return;
  await supabase.storage.from(BUCKET).remove([path]);
}
